export const REGISTER = 'register';
export const REGISTRATION = 'registration';
export const LOGIN = 'login';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = 'reset-password';
export const UPDATE_PASSWORD = 'update-password';
export const RESET_INVALID = 'reset-invalid';
export const SOCIAL_ACCOUNT_LINKED = 'social-account-linked';
export const AUTO_PROMPT_REGISTER = 'AUTO_PROMPT_REGISTER';
export const SOCIAL_CASE_CONNECTION_LINKED = 'LINKED_SOCIAL_CONNECTION';
export const SOCIAL_CASE_ACCOUNT_CREATED = 'Created';
export const SOCIAL_CASE_NO_EMAIL_RETURNED = 'NO_EMAIL_RETURNED';

export const DEFAULT_FLOW = 'DEFAULT';
export const PAGEVIEW_LIMIT_FLOW = 'PAGEVIEW_LIMIT';
export const CONTACT_DEALER_FLOW = 'CONTACT_DEALER_FLOW';
export const CONTACT_DEALER_FORM_FLOW = 'CONTACT_DEALER_FORM';
export const CONTACT_DEALER_CALL_FLOW = 'CONTACT_DEALER_CALL';
export const EMBEDDED_CHECKOUT_FLOW = 'EMBEDDED_CHECKOUT_FLOW';
export const FOLLOW_DEALER_FLOW = 'FOLLOW_DEALER';
export const MAKE_OFFER_FLOW = 'MAKE_OFFER';
export const SAVE_ITEM_FLOW = 'SAVE_ITEM';
export const SAVE_ITEM_TO_FOLDER_FLOW = 'SAVE_ITEM_TO_FOLDER';
export const STALE_LOGIN_FLOW = 'STALE_LOGIN_FLOW';
export const TRADE_APPLICATION_FLOW = 'TRADE_APPLICATION';
export const ALT_REGISTRATION_TRADE_FLOW = 'ALT_REGISTRATION_TRADE';
export const ALT_REGISTRATION_CONSUMER_FLOW = 'ALT_REGISTRATION_CONSUMER';
export const SAVE_ITEM_PDP_FLOW = 'SAVE_ITEM_PDP';
export const REQUEST_SHIPPING_FLOW = 'REQUEST_SHIPPING';
export const BENEFITS_MODAL_FLOW = 'BENEFITS_MODAL_FLOW';

export const CLOSE = 'closed';



// WEBPACK FOOTER //
// ./src/authModal/authentication/authFlowConstants.js